export default __webpack_public_path__ + "static/media/v1.1d558933.jpg";